<template>
    <div class="land-genplan">
        <div class="container">
            <div class="land-genplan-column-container">
                <div class="col-left">
                    <div class="land-section-title">
                        <h2>{{salesCard.project_land_site.genplan_title}}</h2>
                        <h3>{{salesCard.project_land_site.genplan_title_desc}}</h3>
                    </div>
                    <div class="desc-main" v-html="salesCard.project_land_site.genplan_desc"></div>
                    <div class="genplan-img-mobile genplan-map-mobile">
                        <img :src="salesCard.project_land_site.genplan_img" alt="" id="genplan-mobile-map">
                    </div>
                    <!-- <div class="desc-under" v-html="salesCard.project_land_site.about_desc_under"></div> -->
                </div>
                <div class="col-right">
                    <div class="col-img">
                        <img :src="salesCard.project_land_site.genplan_img" alt="">
                    </div>
                </div>
            </div>
            <div class="genplan-pins">
                <div class="pin-item" v-for="(item, index) in salesCard.project_land_site.genplan_pins" :key="index">
                    <div class="upper">
                        <div class="item-img">
                            <img :src="item.icon" alt="">
                        </div>
                        <h3 v-html="item.name"></h3>
                    </div>
                    <h4>{{item.more}}</h4>
                </div>
            </div>
        </div>
    </div>   
</template>

<script>
    import {mapGetters} from 'vuex'
    // import PROMOpage from '@/components/sales/sales-promo-page.vue'
    export default {
        name: 'sale-land-genplan',
        components: {
        },
        data () {
            return {
            }
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            salesCardPage: 'loadSalesCardPage',
        }),
        methods: {
            initPinchZoomer() {
                var _self = this;
                var image = new Image();
                image.onload = function () {
                    if ($(window).width() < 800) {
                        $("#genplan-mobile-map").pinchzoomer({
                            initZoom: 1,
                            minZoom: 1,
                        });
                    }
                }
                image.src = _self.salesCard.project_land_site.genplan_img;
            }
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
            this.initPinchZoomer();
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales/sales-land-partials/land-genplan.scss';
    @import '@/styles/respond/sales/sales-land-partials/land-genplan-respond.scss';
    // @import '@/styles/respond/sales/respond-sale-item.scss';
</style>